export default __webpack_public_path__ + "static/media/plan-a-media-group-plan-a-live-4.d02715e0.JPG";